<template>
  <div class="error-wrapper">
    <div class="wrapper">
      <h1>Referral not available</h1>
      <p>{{ name }} not have access to this referral</p>
      <p class="text-muted" v-if="isOtherLogins">
        <b>Note:</b> You have access to other practices. Use your user menu

        <!-- <i class="d-inline-flex align-items-center"
            ><font-awesome-icon
              icon="user-circle"
              class="mr-1"
              style="vertical-align: middle; background: #e8e8ea; border-radius: 1.25em"
            />
            User menu</i
          > -->
        in the top right and try the "Switch user" feature.
      </p>
      <div
        v-if="!isPremium && totalCount > 2 && totalCount - referrals.length > 1"
        class="mt-3 alert alert-warning font-weight-bold"
        @click.prevent.stop="withPremium"
        style="cursor: pointer"
      >
        You have only have access to <b>7 days of referrals</b>, if the referral is older then you need to upgrade for
        access.
        <a class="font-weight-bolder btn btn-warning d-block mt-3" href="javascript:void(0);">Upgrade now</a>
      </div>
      <div class="buttons">
        <router-link
          v-if="$route.name == 'create-referral-public'"
          :to="{ name: 'create-referral-public', params: { to: $route.params.to || null } }"
          class="btn btn-lg btn-primary"
          >Create new referral</router-link
        >
        <router-link v-else to="/" class="btn btn-lg btn-primary">Back to dashboard</router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
export default {
  computed: {
    ...mapState('auth', ['user']),
    ...mapGetters('billing', ['isPremium']),
    ...mapState('referrals', ['referrals', 'totalCount']),
    name() {
      return (!this.user?.is_public && this.user?.practice?.name && `${this.user?.practice?.name} does`) || 'You do'
    },
    isOtherLogins() {
      return this.user?.practices?.length > 1
    },
  },
  mounted() {},
}
</script>
